export default __webpack_public_path__ + "static/media/x_delete_file.82af6f2e.svg";